import request from '@/request/index';
import util from '@/libs/util';

//病症分类
export function bzflDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//证件类型
export function IDCardDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//医疗技术
export function yljsDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//报考专业
export function MajorDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//考核类别
export function assessmentDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//执业类别
export function ZYLBDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//民族
export function NationDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//学历
export function eduDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//学位
export function degreeDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//职务
export function postDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//职务
export function studyTypeDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

//步骤一下一步校验
export function nextStep1(data) {
    return request({
        url: '/webapi/api/user_info',
        method: 'put',
        data
    });
}

//四川城市列表
export function sichaunCity(urlParms) {
    let parmas = (urlParms) ? '?' + (util.tool.urlPath(urlParms)) : "";
    return request({
        url: '/webapi/api/org_info/org_children_ins/' + parmas,
        method: 'get'
    });
}

// 湖北省所有街道
export function sichaunStreet() {
    return request({
        url: '/webapi/api/org_info/org_street_ins' ,
        method: 'get'
    });
}

// 学习途径
export function xxtjDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}

// 文化程度
export function educationDictionaries(code) {
    return request({
        url: '/webapi/api/dataitem/' + code,
        method: 'get'
    });
}